/**
 * Telefone brasileiro: mascara e conferencia de comprimento.
 *
 * Dez digitos (fixo) e onze (celular) sao os dois formatos aceitos. Nao ha
 * validacao de operadora nem de DDD existente: o objetivo e barrar o numero
 * digitado pela metade, que e o erro que realmente acontece num formulario
 * longo — nao o DDD inventado.
 */

import { onlyDigits } from "@/shared/lib/documents"

const LANDLINE_DIGITS = 10
const MOBILE_DIGITS = 11

/** (00) 0000-0000 ou (00) 00000-0000, conforme a quantidade de digitos. */
export function formatPhone(value: string): string {
  const d = onlyDigits(value).slice(0, MOBILE_DIGITS)

  if (d.length <= 2) return d
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= LANDLINE_DIGITS) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`

  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

export function isValidPhone(value: string): boolean {
  const length = onlyDigits(value).length
  return length === LANDLINE_DIGITS || length === MOBILE_DIGITS
}
